import { render, staticRenderFns } from "./ContactDetail.vue?vue&type=template&id=95c0914c"
import script from "./ContactDetail.vue?vue&type=script&lang=js"
export * from "./ContactDetail.vue?vue&type=script&lang=js"
import style0 from "./ContactDetail.vue?vue&type=style&index=0&id=95c0914c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports